/**
 * Categoría en Academy Service (MongoDB `knowledgepages`) para el manual
 * «Operador audiovisual TNO Network». Debe coincidir con el seed del servicio academy.
 */
export const WIKI_OPERADOR_AUDIOVISUAL_CATEGORY = 'wiki-operador-audiovisual-tno';
